<template>
  <div class="login" :style="bga">

   <!--  <router-link to="/a">home</router-link>
    <router-link to="/b">about</router-link> -->
    

      <router-view></router-view>



    <!-- <component :is="com" @add="addone"></component> -->
    <!-- <router-link to="/a/">Home</router-link> -->

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/>
     <router-view></router-view>  -->

  </div>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!-- <Login2></Login2> -->


</template>

<script setup>
//import { set } from "lodash"
import { ref,shallowRef, defineProps, reactive, onMounted } from "vue"

import HelloWorld from './components/HelloWorld.vue'
import Login222 from './components/login.vue'
import Login2 from './components/login2.vue'
import register2 from './components/register2.vue'




//动态背景
let arr =new Array();
arr.push('A01.jpg','A02.jpg','A03.jpg','A04.jpg','A05.jpg','A06.jpg');
let bg = Math.floor((Math.random() * arr.length));

let img = arr[bg];

//img = 'A07.jpg';

console.log('阿萨',img);

let imgg = require('./assets/login/'+img);
const bga = {backgroundImage:`url(${imgg})`};
  


const components= {
  Login2,
  register2,
}
const com = shallowRef(register2);


const addone = (text) => {
  console.log('hahha',text);

  com.value= components[text];

}

onMounted(() => {


})


/* export default {
  name: 'App',
  components: {
    HelloWorld,
    Login222,
    Login2
  }
} */

</script>

<style scoped lang="less">
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
} */

.login {
  width: 100%;
  height: 100vh;

 //background-image: url("./assets/login/A01.jpg" ); //背景图
  background-size: 100% 100vh;
   //background-size: 1920px 1200px;
  background-position: center center;
  overflow: auto;
  position: relative;
  }
</style>
